import React from "react";

function CarDriverIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsAndroid="http://schemas.android.com/apk/res/android"
      width="44"
      height="44"
    >
      <path
        fill="#DBE8ED"
        stroke="#FFF"
        strokeWidth="4"
        d="M-2-2h48v48H-2z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#6DBA3F"
        stroke="#00000000"
        d="M21.797 4.143c-1.2 0-1.68 1.003-1.68 1.003h3.36s-.48-1.003-1.68-1.003"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#332928"
        stroke="#00000000"
        d="M31.651 18.277s-.11 1.493-.079 1.828c.032.335-1.367.915-1.367.915l-.446-2.903 1.892.16z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#D38A6A"
        stroke="#00000000"
        d="M30.293 21.145c.265-.997.624-1.423 1.075-1.277.677.219 1.14 2.54-1.28 3.824-1.613.856-1.545.007.205-2.547z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#332928"
        stroke="#00000000"
        d="M11.852 18.353s.11 1.494.08 1.828c-.032.335 1.367.915 1.367.915l.446-2.903-1.893.16z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#2A7F21"
        stroke="#00000000"
        d="M12.55 10.039c1.2-2.917 4.79-5.079 9.814-5.079 5.023 0 8.613 3.828 9.268 6.718.622 2.744.643 6.674.56 6.955-.084.28-16.97 2.352-20.832.07 0 0-.008-5.748 1.19-8.664z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#D38A6A"
        stroke="#00000000"
        d="M13.104 21.145c-.265-.997-.623-1.423-1.075-1.277-.677.219-1.14 2.54 1.28 3.824 1.613.856 1.545.007-.204-2.547z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#468FBC"
        stroke="#00000000"
        d="M37.507 37.776a22.801 22.801 0 01-15.876 6.401 22.827 22.827 0 01-15.757-6.282c3.715-1.731 10.909-4.748 15.941-4.748 4.921 0 11.909 2.883 15.692 4.63"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#1A6F99"
        stroke="#00000000"
        d="M16.174 34.162s-2.178.364-2.3 2.966c-.12 2.602 3.108 7.05 7.757 7.05 4.65 0 7.763-3.468 8.432-6.415.67-2.948-3.648-4.004-3.648-4.004l-10.24.403z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#F4B28E"
        stroke="#00000000"
        d="M21.282 42.548a6.505 6.505 0 01-1.855-.467c-1.662-.668-2.808-1.866-3.484-2.977-.51-.84-.752-1.634-.736-2.1.036-1.291.832-3.685.832-3.685.049-.367.065-.785.065-1.22-.004-1.67-.29-3.564-.29-3.564l12.223-.757c-.133.76-.197 1.521-.217 2.245a20.99 20.99 0 00.076 2.426c.024.282.053.548.085.797.157 1.243.362 2.048.362 2.048 1.728 2.195-2.203 7.693-7.06 7.254"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#D38A6A"
        stroke="#00000000"
        d="M28.037 27.778c-.133.76-.197 1.521-.217 2.245-.923 3.124-2.202 4.965-6.161 5.833-2.389.524-5.137 1.985-5.716 3.248-.511-.841-.753-1.633-.736-2.1.036-1.292.833-3.685.833-3.685.048-.367.064-.785.064-1.22-.004-1.67-.29-3.564-.29-3.564l12.223-.757z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#F4B28E"
        stroke="#00000000"
        d="M30.365 23.879a12.693 12.693 0 01-.63 2.4c-.122.34-.262.674-.41 1.005-.55 1.213-1.689 2.689-2.83 3.722-.428.382-.853.706-1.249.929-1.188.67-2.387.954-3.553.926-1.17.028-2.369-.256-3.557-.926-.4-.226-.831-.554-1.264-.943-1.133-1.03-2.264-2.498-2.812-3.708a13.356 13.356 0 01-.41-1.004 13.089 13.089 0 01-.482-1.62 12.946 12.946 0 01-.147-.781c-.242-1.588-.343-4.248-.386-6.156 2.66-.847 5.984-1.35 9.058-1.35 3.07 0 6.39.5 9.054 1.35-.04 1.908-.14 4.568-.382 6.156z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#6DBA3F"
        stroke="#00000000"
        d="M21.64 12.857c4.266 0 8.092 2.01 9.593 4.261 0 0 .552 1.058 0 1.51-.553.453-1.043.765-1.39 1.152-.348.388-3.034-3.068-8.203-3.068v-3.855z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#6DBA3F"
        stroke="#00000000"
        d="M21.653 12.857c-4.072 0-8.092 2.01-9.592 4.261 0 0-.553 1.058 0 1.51.552.453 1.042.765 1.39 1.152.348.388 3.033-3.068 8.202-3.068v-3.855z"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#FFF"
        stroke="#00000000"
        d="M23.343 11.038a.451.451 0 01-.281-.787l.104.18a.238.238 0 00.158.406.238.238 0 10-.01-.475l-.106-.198a.451.451 0 11.135.874zm-.756-1.751c-.412-.031-.769.143-.769.143s-.012.016-.025 0a.424.424 0 01-.08-.179l.17-.398c.133.166.707.342.707.342l-.003.092zm-1.869 1.727a.45.45 0 01-.432-.443l.191.007a.258.258 0 10.517.02l.19.009a.45.45 0 01-.466.407zm.037-.9a.4.4 0 01.062.008l-.064.21-.005-.001a.258.258 0 00-.248.15l-.205-.008a.45.45 0 01.46-.358zm.223.07a.45.45 0 01.205.325l-.204-.008a.255.255 0 00-.087-.117l.086-.2zm2.403-.254a.659.659 0 00-.27.046c-.088-.171-.163-.326-.147-.326l.175.007s.023-.215.014-.334c-.01-.12-.052-.121-.052-.121l-.156.05c-.184.062-.212.047-.212.047s.002-.184-.033-.186a2.429 2.429 0 01-.206-.043c-.014-.028-.13-.088-.19-.133-.067-.076-.301-.243-.47-.36a.304.304 0 10-.162-.11l-.023-.016c-.04-.036-.086.012-.086.012l-.411.822c-.023.048.07.15.07.15l-.532.013c-.091.003-.159.308-.159.308-.353.063-.56.495-.56.495l.09.066-.007.146-.16-.006c-.059.06-.004.098-.004.098l.16.006v.028h0a.686.686 0 001.37.053c.074 0 .412-.003.63-.001.244.002.306-.142.306-.142l.02-.509s.154.006.226-.026c.07-.032.176-.202.176-.202l.175.301a.667.667 0 00.375 1.204.67.67 0 10.053-1.337zM20.563 7.066c.112-.069 1.434-1.002 2.802.054 0 0 .148-.036.138-.133-.01-.098-1.404-1.222-3.102-.074-.05.035.05.222.162.153"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#FFF"
        stroke="#00000000"
        d="M20.885 7.49c.085-.055 1.094-.804 2.137.043 0 0 .12-.028.112-.106-.008-.078-1.071-.98-2.366-.06-.038.028.032.178.117.123"
        androidFillType="evenOdd"
      ></path>
      <path
        fill="#FFF"
        stroke="#00000000"
        d="M21.251 7.87c.056-.04.72-.579 1.408.032 0 0 .074-.03.07-.086-.005-.056-.706-.706-1.56-.043-.025.02.026.137.082.097"
        androidFillType="evenOdd"
      ></path>
    </svg>
  );
}

export default CarDriverIcon;
